import { TopbarDesktopConfigType } from 'components/Topbar/Desktop/TopbarDesktop.types'
import { TopbarMobileConfigType } from 'components/Topbar/Mobile/TopbarMobile.types'
import { TopbarDesktopSlotLeft } from 'brands/opopular/assets/topbar.styled'
import * as S from './topbar.styled'

export interface TopbarConfigType { topbarMobile: TopbarMobileConfigType; topbarDesktop: TopbarDesktopConfigType; }

export const topbar: TopbarConfigType = {
  topbarMobile: {
    mainLogo: 'LogoCBNMobile',
    css: {
      cssContainer: {
        background: '#F7F7F7',
        boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.1)',
        height: '52px',
        width: '100%'
      },
      cssContainerMiddleHolder: {
        height: '100%',
        width: '100%'
      },
      cssContainerMiddle: {
        align: ['row', 'between', 'middle'],
        height: '100%',
        width: '100%'
      },
      cssContainerMiddleSlotLeft: {
        align: ['row', 'left', 'middle'],
        paddingLeft: '18px',
        width: '80px'
      },
      cssContainerMiddleSlotRight: {
        align: ['row', 'right', 'middle'],
        paddingRight: '18px',
        width: '80px'
      },
      cssContainerBottom: {
        display: 'none'
      }
    },
    slotMiddleLeft: S.TopbarMobileSlotLeft
  },
  topbarDesktop: {
    mainLogo: 'LogoCBNDesktop',
    css: {
      cssContainerTopHolder: {
        align: ['row', 'center', 'middle'],
        background: '$primaryMain',
        px: '$4',
        width: '100%'
      },
      cssContainerTop: {
        align: ['row', 'between', 'middle'],
        height: '32px',
        maxWidth: '1280px'
      },
      cssContainerTopSlotRight: {
        align: ['row', 'right', 'middle']
      },
      cssContainerMiddleHolder: {
        align: ['row', 'center', 'middle'],
        background: '#F7F7F7',
        px: '$4',
        width: '100%'
      },
      cssContainerMiddle: {
        align: ['row', 'between', 'middle'],
        height: '110px',
        maxWidth: '1280px',
        width: '100%'
      },
      cssContainerMiddleSlotLeft: {
        align: ['row', 'left', 'middle'],
        minWidth: '400px'
      },
      cssContainerMiddleSlotRight: {
        align: ['row', 'between', 'middle'],
        minWidth: '400px'
      },
      cssContainerBottomHolder: {
        align: ['row', 'center', 'middle'],
        background: '#F7F7F7',
        px: '$4',
        width: '100%',
        ' > div': {
          align: ['row', 'between', 'middle'],
          borderTop: '1px solid #E6E6E6',
        }
      },
      cssContainerBottom: {
        align: ['row', 'between', 'middle'],
        background: '#F7F7F7',
        height: '40px',
        maxWidth: '1280px',
        width: '100%'
      },
      cssContainerBottomLeft: {
        align: ['row', 'right', 'middle'],
        minWidth: '170px'
      },
      cssContainerBottomRight: {
        align: ['row', 'right', 'middle'],
        minWidth: '170px'
      },
      topbarItems: {
        item: {
          label: {
            color: '#202020',
            fontSize: '14px',
            fontFamily: '$primary',
            fontWeight: 500,
            textTransform: 'uppercase',
            width: 'max-content'
          },
          li: {
            'a': {
              borderBottom: '4px solid transparent',
              cursor: 'pointer',
              display: 'block',
              height: '100%',
              width: '100%',
              pb: '6px',
              pr: '$4',
              pt: '10px',
            }
          }
        }
      }
    },
    slotTopLeft: S.TopbarTopSlotLeft,
    slotTopRight: S.TopbarTopSlotRight,
    slotMiddleLeft: TopbarDesktopSlotLeft,
    slotMiddleRight: S.TopbarDesktopSlotRight,
    slotBottomRight: S.TopbarExtraSlotRight
  }
}

export default topbar
